"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKWizard = exports.transitionIsValid = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../common");
var components_1 = require("../../components");
var GKWizardStepTab_1 = require("./GKWizardStepTab");
require("./GKWizard.css");
/**
 * Encapsulates transition step transistion logic, mostly for unit testing purposes
 * @internal
 */
var transitionIsValid = function (transistion, stepMetadata) {
    var source = transistion.from, target = transistion.to;
    if (target === source ||
        !stepMetadata ||
        stepMetadata.length < target + 1 ||
        stepMetadata.length < source + 1) {
        return false;
    }
    var targetInBounds = target >= 0 && target <= stepMetadata.length;
    var targetValid = stepMetadata[target].isVisited || target - source === 1;
    var canLeaveCurrentStep = 
    // can always leave last step
    source + 1 === stepMetadata.length ||
        // can leave final visited step
        (source + 1 < stepMetadata.length &&
            stepMetadata.slice(source + 1).every(function (md) { return md.isVisited !== true; })) ||
        // otherwise step must be valid
        stepMetadata[source].isValid;
    var pathToTargetExists = 
    // can always go back
    target <= source ||
        // otherwise every step between source and target must be valid
        stepMetadata.slice(source, target).every(function (md) { return md.isValid; });
    return (targetInBounds && targetValid && canLeaveCurrentStep && pathToTargetExists);
};
exports.transitionIsValid = transitionIsValid;
/**
 * Wizard/Stepper component for guided, step-by-step workflows. This component provides a wrapper for individual
 * step components provided by the consumer (extend GKWizardStep) along with a header which provides
 * an indicator of overall progress and the option to jump between steps, customizable next and previous navigation
 * buttons in the footer, and logic to control navigation between. If step transitions depend on asynchronous processes,
 * the wizard also includes lifecycle callbacks and blocking loading indicator.
 * Note: It is the responsibility of the individual steps to indicate when they become valid.
 *
 * @remarks
 * This is a strictly linear wizard which makes some assumptions about state transistions, both via the navigation
 * buttons in the UI and from the instance public API
 * * If a consuming component skips to a step on mount, it is assumed that all preceding steps are complete
 * * The user may always navigate to an earlier step from the last visited step regardless of validity
 * * If the user returns to a prior step, they may not navigate away until it is valid
 * * The user may only proceed to the next un-visited step if all visited steps are valid
 */
var GKWizard = /** @class */ (function (_super) {
    __extends(GKWizard, _super);
    function GKWizard(props) {
        var _this = _super.call(this, props) || this;
        // PUBLIC METHODS
        /**
         * Proceed to the next wizard step if all conditions to do so are met.
         * @returns a promise which is resolved when succesful or rejected if not.
         */
        _this.next = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jumpTo(this.state.currentStep + 1)];
            });
        }); };
        /**
         * Proceed to the previous wizard step if all conditions to do so are met.
         * @returns a promise which is resolved when succesful or rejected if not.
         */
        _this.back = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.state.currentStep > 0) {
                    return [2 /*return*/, this.jumpTo(this.state.currentStep - 1)];
                }
                else {
                    return [2 /*return*/, Promise.reject("[GKWizard]: cannot navigate backwards from first step")];
                }
                return [2 /*return*/];
            });
        }); };
        /**
         * Proceed to a specified step if all conditions to do so are met.
         * @param index the target step's index (zero-referenced)
         * @returns a promise which is resolved when succesful or rejected if not.
         */
        _this.jumpTo = function (index) { return __awaiter(_this, void 0, void 0, function () {
            var _a, stepWillChange, steps, currentStep;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setState({ isLoading: true });
                        _a = this.props, stepWillChange = _a.stepWillChange, steps = _a.steps;
                        currentStep = this.state.currentStep;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 7, 8]);
                        if (!(index === steps.length)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.finish()];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 3:
                        if (!this.canJumpTo(index)) return [3 /*break*/, 5];
                        return [4 /*yield*/, Promise.resolve(stepWillChange && stepWillChange({ from: currentStep, to: index }))];
                    case 4:
                        _b.sent();
                        this.setCurrentStep(index);
                        return [3 /*break*/, 6];
                    case 5: throw new Error("[GKWizard]: cannot move to step index " + index + " from " + currentStep);
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        this.setState({ isLoading: false });
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Check whether the wizard can progress legaly to a target step index.
         * @param target the target step's index (zero-referenced)
         * @returns a boolean of whether the transition is legal
         */
        _this.canJumpTo = function (target) {
            return (0, exports.transitionIsValid)({ from: _this.state.currentStep, to: target }, _this.state.stepMetadata);
        };
        // PRIVATE METHODS
        // discard rejected promises: the consumer is managing the promise, let them handle the errors.
        _this.simpleNext = function () {
            return _this.next().catch(function () {
                return;
            });
        };
        _this.simpleBack = function () {
            return _this.back().catch(function () {
                return;
            });
        };
        _this.simpleJump = function (to) {
            return _this.jumpTo(to).catch(function () {
                return;
            });
        };
        _this.finish = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, currentStep, steps, _b, willFinish, onFinish, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.state, currentStep = _a.currentStep, steps = _a.stepMetadata;
                        _b = this.props, willFinish = _b.willFinish, onFinish = _b.onFinish;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 5, , 6]);
                        if (!steps[currentStep].isValid) return [3 /*break*/, 3];
                        return [4 /*yield*/, Promise.resolve(willFinish && willFinish())];
                    case 2:
                        _c.sent();
                        this.updateStepMetadata(currentStep, { isComplete: true });
                        if (onFinish) {
                            onFinish();
                        }
                        return [3 /*break*/, 4];
                    case 3: throw new Error("[GKWizard]: cannot finish wizard, final step is invalid");
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _c.sent();
                        throw e_1;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.initializeMetadata = function () {
            var _a = _this.props, steps = _a.steps, startingStep = _a.startingStep;
            var currentStep = startingStep || 0;
            var stepMetadata = steps.map(function (s, i) {
                var newMetadata = {
                    index: i,
                    isComplete: i < currentStep,
                    isValid: i < currentStep,
                    isVisited: i <= currentStep,
                };
                return newMetadata;
            });
            _this.setState({ stepMetadata: stepMetadata, currentStep: currentStep });
        };
        _this.cloneComponents = function () {
            var steps = _this.props.steps;
            var componentClones = steps.map(function (step, i) {
                return React.cloneElement(step.component, {
                    ref: function (ref) { return _this.configureRef(ref, i); },
                });
            });
            _this.setState({ componentClones: componentClones });
        };
        _this.setCurrentStep = function (target) {
            var _a = _this.state, source = _a.currentStep, stepMetadata = _a.stepMetadata;
            var stepDidChange = _this.props.stepDidChange;
            _this.updateStepMetadata(source, {
                isComplete: stepMetadata[source].isValid,
            });
            _this.updateStepMetadata(target, { isVisited: true });
            _this.setState({ currentStep: target }, function () {
                if (stepDidChange) {
                    stepDidChange({ from: source, to: target });
                }
            });
            return true;
        };
        _this.updateStepMetadata = function (index, updates) {
            _this.setState(function (_a) {
                var previousStepMetadata = _a.stepMetadata;
                var updatedMetadata = Object.assign({}, previousStepMetadata[index], updates);
                Object.freeze(updatedMetadata); // make sure consumer doesn't try to edit (for our non-TS friends)
                // const updatedMetadata: IGKWizardStepMetadata = Object.assign({}, previousStepMetadata[index], { metadata });
                var newStepMetadata = previousStepMetadata.map(function (oldMetadata, i) {
                    return i === index ? updatedMetadata : oldMetadata;
                });
                return { stepMetadata: newStepMetadata };
            });
        };
        _this.configureRef = function (ref, myIndex) {
            if (ref) {
                ref._GK_INTERNAL_SET_STEP_VALIDITY = function (value) {
                    _this.updateStepMetadata(myIndex, { isValid: value });
                };
                ref._GK_INTERNAL_GET_STEP_VALIDITY = function () {
                    return _this.state.stepMetadata[myIndex].isValid;
                };
                if (ref._GK_INTERNAL_INITIAL_VALIDITY !== null) {
                    _this.updateStepMetadata(myIndex, {
                        isValid: ref._GK_INTERNAL_INITIAL_VALIDITY,
                    });
                    ref._GK_INTERNAL_INITIAL_VALIDITY = null;
                }
                ref.forceUpdate();
            }
        };
        _this.state = {
            componentClones: [],
            currentStep: props.startingStep || 0,
            stepMetadata: [],
        };
        return _this;
    }
    GKWizard.prototype.componentDidMount = function () {
        this.initializeMetadata();
        this.cloneComponents();
    };
    GKWizard.prototype.componentDidUpdate = function (oldProps) {
        var _a = this.props, newSteps = _a.steps, newStartingStep = _a.startingStep;
        var oldSteps = oldProps.steps, oldStartingStep = oldProps.startingStep;
        if (oldSteps !== newSteps || oldStartingStep !== newStartingStep) {
            if (oldSteps.length !== newSteps.length ||
                oldStartingStep !== newStartingStep) {
                this.initializeMetadata();
            }
            this.cloneComponents();
        }
    };
    GKWizard.prototype.render = function () {
        var _this = this;
        var _a = this.state, currentStep = _a.currentStep, componentClones = _a.componentClones, isLoading = _a.isLoading, stepMetadata = _a.stepMetadata;
        var _b = this.props, 
        // Intentionally destructured from otherProps
        /* eslint-disable @typescript-eslint/no-unused-vars */
        children = _b.children, _c = _b.finishButtonLabel, finishButtonLabel = _c === void 0 ? "Finish" : _c, onFinish = _b.onFinish, stepWillChange = _b.stepWillChange, stepDidChange = _b.stepDidChange, startingStep = _b.startingStep, 
        /* eslint-enable @typescript-eslint/no-unused-vars */
        steps = _b.steps, 
        // Intentionally destructured from otherProps
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        willFinish = _b.willFinish, _d = _b["data-qa"], baseQA = _d === void 0 ? "gk-wizard" : _d, otherProps = __rest(_b, ["children", "finishButtonLabel", "onFinish", "stepWillChange", "stepDidChange", "startingStep", "steps", "willFinish", "data-qa"]);
        var currentStepMetadata = stepMetadata[currentStep];
        var backText = steps[currentStep].backButtonLabel || "Back";
        var nextText = steps[currentStep].nextButtonLabel || "Next";
        var currentStepQA = baseQA + "--" + (steps[currentStep]["data-qa"] || "step" + (currentStep + 1));
        return (React.createElement("div", __assign({}, (0, common_1.mapDefaultProps)(otherProps, {
            _gkComponentName: "gk-wizard",
            "data-qa": baseQA,
        })),
            React.createElement(components_1.GKLoading, { id: this.uniqueId + "-loader", type: components_1.GKLoadingType.Spinner, overlay: true, isLoading: isLoading || false },
                React.createElement("div", { className: "gk-wizard-timeline d-lg-flex border-bottom" }, stepMetadata.map(function (metadata, i) { return (React.createElement(GKWizardStepTab_1.GKWizardStepTab, { active: currentStep === i, key: _this.uniqueId + "-header" + i, data: metadata, validNavTarget: _this.canJumpTo(i), onNav: _this.simpleJump, stepCount: stepMetadata.length, stepLabel: steps[i].stepLabel, subtitle: steps[i].subtitle, title: steps[i].title, "data-qa": baseQA + "--" + (steps[i]["data-qa"] || "step" + (i + 1)) + "--tab" })); })),
                React.createElement("div", { className: "gk-wizard-body", "data-qa": currentStepQA + "--body" },
                    React.createElement("div", { className: "gk-wizard-content" }, currentStepMetadata && componentClones[currentStep]),
                    React.createElement("div", { className: "gk-wizard-footer d-flex justify-content-between border-top" },
                        React.createElement("div", { className: "gk-wizard-back-button-container" }, currentStep >= 1 ? (React.createElement(components_1.GKButton, { "data-qa": currentStepQA + "--back", color: "link", onClick: this.simpleBack, disabled: !this.canJumpTo(currentStep - 1) },
                            React.createElement(components_1.GKIcon, { name: components_1.GKIconName.KeyboardArrowLeft }),
                            backText)) : null),
                        React.createElement("div", { className: "gk-wizard-next-button-container" },
                            React.createElement(components_1.GKButton, { "data-qa": currentStepQA + "--next", color: "primary", onClick: this.simpleNext, disabled: !currentStepMetadata || !currentStepMetadata.isValid },
                                currentStep < stepMetadata.length - 1
                                    ? nextText
                                    : finishButtonLabel,
                                React.createElement(components_1.GKIcon, { name: components_1.GKIconName.KeyboardArrowRight }))))))));
    };
    return GKWizard;
}(common_1.GKPureComponent));
exports.GKWizard = GKWizard;
